import "./CookieBanner.scss";
import { Button, Row } from "@/components";

export type CookieBannerProps = {
  hasThirdPartyCookies?: boolean;
  hasTechnicalCookies?: boolean;
  onPressAcceptThirdPartCookie: () => void;
  onPressAcceptTechnicalCookie: () => void;
  onCloseBanner: () => void;
  onPressCookieLink: () => void;
  onlyTechniciansLabel: string;
  acceptLabel: string;
  text: string;
  textSecond: string;
};

export const CookieBanner = ({
  onlyTechniciansLabel,
  text,
  textSecond,
  acceptLabel,
  onPressCookieLink,
  hasThirdPartyCookies = false,
  hasTechnicalCookies = true,
  onPressAcceptThirdPartCookie,
  onPressAcceptTechnicalCookie,
  onCloseBanner,
}: CookieBannerProps) => {
  return (
    <div className={"ui-cookie-banner-container-fixed"}>
      <Row
        gap={"x20"}
        alignItems={"center"}
        justifyContent={"space-between"}
        className={"ui-cookie-banner-container bg-slate-20"}
      >
        <Row>
          <div className={"ui-cookie-banner-text-container"}>
            <span className={"text-white fs-7"}>{text}</span>{" "}
            <div>
              <span className={"text-white fs-7"}>{textSecond}</span>{" "}
              <span
                className={"text-white fs-7 ui-cookie-banner-text-link"}
                onClick={onPressCookieLink}
              >
                cookie policy
              </span>
            </div>
          </div>
        </Row>
        {hasTechnicalCookies && hasThirdPartyCookies && (
          <Row gap={"x16"} className={"cookie-banner-buttons-container"}>
            <Button
              className={"ui-cookie-banner-first-button"}
              onClick={() => {
                onPressAcceptTechnicalCookie();
                onCloseBanner();
              }}
            >
              {onlyTechniciansLabel}
            </Button>
            <Button
              className={"ui-cookie-banner-second-button"}
              variant={"secondary"}
              onClick={() => {
                onPressAcceptThirdPartCookie();
                onPressAcceptTechnicalCookie();
                onCloseBanner();
              }}
            >
              {acceptLabel}
            </Button>
          </Row>
        )}
        {hasTechnicalCookies && !hasThirdPartyCookies && (
          <Row gap={"x16"} className={"cookie-banner-buttons-container"}>
            <Button
              className={"ui-cookie-banner-second-button"}
              variant={"secondary"}
              onClick={() => {
                onPressAcceptTechnicalCookie();
                onCloseBanner();
              }}
            >
              {acceptLabel}
            </Button>
          </Row>
        )}
      </Row>
    </div>
  );
};
